<lib-prod-header [title]="title" [icon]="'account_tree'">
  <div class="organization-wrapper">
    <div class="clear-input-wrapper">
      <input class="tree-input"
             #treeInput
             [(ngModel)]="mainFilterValue"
             (ngModelChange)="onChangeFilter()"
             placeholder="&#xF002;"
             spellcheck="false"
             autocomplete="off">
      <mat-icon [ngClass]="treeInput.value ? 'clear-input' : 'display-none'"
                (click)="clearFilters()">close
      </mat-icon>
    </div>

    <mat-tree [dataSource]="filteredDataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle
                     [ngClass]="{'company': node.organizationType.id === 1, 'site': node.organizationType.id === 2}"
                     (click)="onSelectNode(node)" [tabindex]='0'>
        <mat-icon>{{ getIcon(node) }}</mat-icon>
        {{ node.name }}
      </mat-tree-node>

      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
                            [ngClass]="{'company': node.organizationType.id === 1, 'site': node.organizationType.id === 2}"
                            (click)="onSelectNode(node)" [tabindex]='0'>
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="sup-icon">{{ getIcon(node) }}</mat-icon>
            <mat-icon class="sub-icon">{{ treeControl.isExpanded(node) ? 'remove_circle' : 'add_circle' }}</mat-icon>
          </button>
          {{ node.name }}
        </div>
        <div [class.tree-invisible]="!treeControl.isExpanded(node)"
             role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>


    <div class="bottom-bar">
      <button (click)="treeControl.expandAll()"><mat-icon>expand_more</mat-icon></button>
      <button (click)="treeControl.collapseAll()"><mat-icon>expand_less</mat-icon></button>
      <button (click)="addNewCompany()" class="add-button">{{'organizations.add_company' | translate }}</button>
      <button (click)="addNewDistributor()" class="add-button">{{'organizations.add_distributor' | translate }}</button>
      <span class="spacer"></span>
      <input id="secondaryFilter" class="search-icon-placeholder"
             placeholder="&#xF002;"
             [(ngModel)]="secondaryFilterValue"
             (ngModelChange)="onChangeFilter()"
             spellcheck="false"
             autocomplete="off">
    </div>

  </div>
</lib-prod-header>
